module.exports = __webpack_public_path__ + "img/CARA_SLOPE.69a2719b.jpg";